//import Swal from "sweetalert2";
//import Vue from "vue";
import { getGifts, getGift, deleteGift, saveGift, updateGift} from '@/services/modules/gift'

export const state = {
  gifts: []
}

export const mutations = {
  setGifts (state, data) {
    state.gifts = data.data
  }
}

export const getters = {
  getGifts (state) {
    return state.gifts
  }
}

export const actions = {
  async getGifts (context) {
    // eslint-disable-next-line no-unused-expressions
  
    const result = await getGifts()
    context.commit('setGifts', result.data)
    return result.data
  },
  
  async saveGift (context, { payload }) {
    const result = await saveGift(payload)
    if (result.data.status) {
      context.dispatch('getGifts')
    }
    return result.data
  },
  
  async updateGift (context, { payload }) {
    const result = await updateGift(payload)
    if (result.data.status) {
      context.dispatch('getGifts')
    }
    return result.data
  },
  
  async deleteGift (context, { giftId }) {
    const result = await deleteGift(giftId)
    if (result.data.status) {
      context.dispatch('getGifts')
    }
    return result.data
  },
  async getGift (context, { giftId }) {
    const result = await getGift(giftId)
    return result.data
  }
}
